// What the join-requests queue shows for each request (board #398). Pure, so it is tested on its own.

export function verificationLabel(r) {
  if (r?.verified) return "Verified";
  if (r?.verification_status === "pending") return "Selfie in review";
  if (r?.verification_status === "rejected") return "Selfie rejected";
  return "Not verified";
}

// Who sent them: the invite the server resolved, else the name they typed.
export function referralLine(r) {
  const plan = r?.application?.invite_plan_title;
  if (r?.invited_by?.name) return plan ? `Invited by ${r.invited_by.name} to ${plan}` : `Invited by ${r.invited_by.name}`;
  if (r?.application?.referral_note) return `Says referred by ${r.application.referral_note}`;
  return null;
}

// The accounts they gave, as links to check.
export function socialLinks(app) {
  if (!app) return [];
  const out = [];
  if (app.instagram) out.push({ label: `Instagram @${app.instagram}`, href: app.instagram_url || `https://www.instagram.com/${app.instagram}` });
  if (app.tiktok) out.push({ label: `TikTok @${app.tiktok}`, href: app.tiktok_url || `https://www.tiktok.com/@${app.tiktok}` });
  if (app.linkedin && /^https:\/\/www\.linkedin\.com\//.test(app.linkedin)) out.push({ label: "LinkedIn", href: app.linkedin });
  return out;
}

export const isPriority = (r) => !!(r?.invited_by || r?.application?.referral_note || r?.verified);

export function matchesSearch(r, q) {
  const needle = String(q || "").trim().toLowerCase();
  if (!needle) return true;
  const a = r?.application || {};
  return [r?.firstName, r?.lastName, r?.email, r?.phone, a.instagram, a.tiktok, a.linkedin, a.about, a.referral_note, a.invite_plan_title, r?.invited_by?.name]
    .filter(Boolean)
    .some((v) => String(v).toLowerCase().includes(needle));
}
